import { Button, Typography, useTheme } from '@mui/material'
import { FlexBoxColumn } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'
import { NoDataIcon } from 'icons'

export const ErrorSection = ({ error }: { error: string }) => {
    const theme = useTheme()
    const { handleTrackingEvent, mainColor } = useBetContext()
    return (
        <>
            <FlexBoxColumn sx={{ mt: 2 }}>
                <NoDataIcon />
                <Typography
                    variant="text-12-semi-bold"
                    sx={{
                        color: theme.palette.text.secondary,
                        width: '80%',
                        textAlign: 'center',
                        mt: 2
                    }}
                >
                    {error}
                </Typography>
            </FlexBoxColumn>
            <FlexBoxColumn
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1
                }}
            >
                <Button
                    variant="contained"
                    component={'a'}
                    href="#close"
                    sx={{
                        width: '80%',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        mb: 3.5,
                        backgroundColor: mainColor
                    }}
                    onClick={() => {
                        void handleTrackingEvent({
                            eventType: 'SUBMIT',
                            actionType: 'CLOSE'
                        })
                    }}
                >
                    Fermer
                </Button>
            </FlexBoxColumn>
        </>
    )
}
